import env from "../constants/env";
let firebaseConfig;
env === "dev"
  ? (firebaseConfig = {
      apiKey: "AIzaSyBOR353nw1MZ46tham8eSj7r0ODQIvRlsM",
      authDomain: "srvhub-testing.firebaseapp.com",
      databaseURL: "https://srvhub-testing-default-rtdb.firebaseio.com",
      projectId: "srvhub-testing",
      storageBucket: "srvhub-testing.appspot.com",
      messagingSenderId: "22268543030",
      appId: "1:22268543030:web:ff1186c2d2f9487c839897",
      measurementId: "G-RQQR9E338P",
    })
  : (firebaseConfig = {
      apiKey: "AIzaSyBP_T_0BjzAR1zXdB41sa68qRCVsGNl0ko",
      authDomain: "stylr-7e48c.firebaseapp.com",
      databaseURL: "https://stylr-7e48c.firebaseio.com",
      projectId: "stylr-7e48c",
      storageBucket: "stylr-7e48c.appspot.com",
      messagingSenderId: "17715522239",
      appId: "1:17715522239:web:3b6284e374959de874340a",
      measurementId: "G-N4BBGDKCMX",
    });

export default firebaseConfig;
